import { EditorContent } from '@tiptap/react';
import { type FC, type RefObject, useImperativeHandle } from 'react';
import { EditorBox } from './style';
import { EditorToolbar } from './Toolbar/EditorToolbar';
import { type UseRichTextEditor, useRichTextEditor } from './useRichTextEditor';

export type RichTextEditorRef = {
  focus: VoidFunction;
};

type Props = {
  value: string;
  onChange: (markdown: string) => void;
  placeholder?: string;
  ariaLabel?: string;
  editorRef?: RefObject<RichTextEditorRef | null>;
};

export const RichTextEditor: FC<Props> = ({
  value,
  onChange,
  placeholder,
  ariaLabel,
  editorRef,
}) => {
  const { editor, focus }: UseRichTextEditor = useRichTextEditor({
    value,
    onChange,
    placeholder,
    ariaLabel,
  });

  useImperativeHandle(editorRef, () => ({ focus }), [focus]);

  return (
    <EditorBox>
      {editor && <EditorToolbar editor={editor} />}
      <EditorContent editor={editor} />
    </EditorBox>
  );
};
